import { observer } from 'mobx-react'
import { useCallback } from 'react'

import HandwrittenNoteTextBox from './HandwrittenNoteTextBox'
import type HandwrittenNoteControllerService from './service/HandwrittenNoteController.service'

const HandwrittenNoteTextBoxLayer = ({
  controllerService,
}: {
  controllerService: HandwrittenNoteControllerService
}) => {
  const { activeTool, isWritingMode, isHiddenNote, noteService } = controllerService

  const handleAddTextBox = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (
        !noteService ||
        !isWritingMode ||
        activeTool !== 'text' ||
        noteService.activeTextBoxId !== null
      ) {
        return
      }

      const target = e.target as HTMLElement
      const isTextBoxElement = target.closest('[data-textbox="true"]')
      if (isTextBoxElement) {
        return
      }

      noteService.handleTextClick({ clientX: e.nativeEvent.layerX, clientY: e.nativeEvent.layerY })
    },
    [isWritingMode, activeTool, noteService],
  )

  if (!noteService) {
    return null
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: isHiddenNote ? 'none' : 'unset',
        pointerEvents: activeTool === 'text' ? 'auto' : 'none',
      }}
      onMouseDown={handleAddTextBox}
    >
      {noteService.noteData.visibleTextItems.map((item) => (
        <HandwrittenNoteTextBox
          key={item.id}
          item={item}
          service={noteService}
          activeTextBoxId={noteService.activeTextBoxId}
          setActiveTextBoxId={(id) => noteService.setActiveTextBoxId(id)}
        />
      ))}
    </div>
  )
}

export default observer(HandwrittenNoteTextBoxLayer)
